import React, { useState }from 'react';
import { useRazorpay } from "react-razorpay";
import { useVerifyPaymentMutation } from "../config/redux/slices/api/paymentApiSlice";
import { useNavigate } from 'react-router-dom';
import { clearOrder } from "../config/redux/slices/orderSlice";
import { clearCart } from "../config/redux/slices/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";

export const useRazorpayPayment = (setAlert) => {
  const { userInfo } = useSelector((state) => state.auth);
  const { Razorpay } = useRazorpay();
  const [verifyPayment] = useVerifyPaymentMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleRazorpayPayment = useCallback((paymentOrder) => {
    
    if (!paymentOrder) {
      setAlert({ type: 'danger', message: 'Order details are missing !' });

      setTimeout(() => {
        setAlert(null); // Auto close after 3s
      }, 3000);
      return;
    }
    console.log("Payment Order:", paymentOrder);

    const options = {
      key: "rzp_live_gFIbBthKK4DHPe",
      currency: "INR",
      order_id: paymentOrder.order_id,
      handler: async (response) => {
        try {
          const res = await verifyPayment({
            data: {
              id: paymentOrder.payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
            },
            token: userInfo.access_token,
          }).unwrap();

          if (res.message === "Payment Accepted Successfully") {
            setAlert({ type: 'success', message: 'Payment successful!' });

            setTimeout(() => {
              setAlert(null); // Auto close after 3s
            }, 3000);
            dispatch(clearCart());
            dispatch(clearOrder());
            navigate("/");
          } else if (res.message === "Unauthenticated.") {
            setAlert({ type: 'danger', message: 'Session expired. Please log in again.' });

            setTimeout(() => {
              setAlert(null); // Auto close after 3s
            }, 3000);
            navigate("/login");
          } else if (res.message === "invalid params") {
            const errorMessages = Object.values(res.errors).flat().join("\n");
            setAlert({ type: 'danger', message: "Payment failed due to invalid input:\n" + errorMessages });

            setTimeout(() => {
              setAlert(null); // Auto close after 3s
            }, 3000);
          } else if (Array.isArray(res) && res.includes("Razorpay payment status verification failed.")) {
            setAlert({ type: 'danger', message: "Payment verification failed. Please try again." });

            setTimeout(() => {
              setAlert(null); // Auto close after 3s
            }, 3000);
          } else {
            setAlert({ type: 'danger', message: "Payment failed. Unexpected response." });

            setTimeout(() => {
              setAlert(null); // Auto close after 3s
            }, 3000);
          }
        } catch (err) {
          console.error("Payment Error:", err);
          setAlert({ type: 'danger', message: "Payment failed: " + (err.message || "An unknown error occurred.") });

          setTimeout(() => {
            setAlert(null); // Auto close after 3s
          }, 3000);
        }
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  }, [ userInfo, Razorpay, dispatch, verifyPayment, navigate]);

  return handleRazorpayPayment;
};
